import checkComplaintDuration from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-information/actions/checkComplaintDuration';
import complaintDurationCustomValidation from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-information/actions/complaintDurationCustomValidation';
import syncStore from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-information/actions/syncStore';

export default {
    checkComplaintDuration,
    complaintDurationCustomValidation,
    syncStore,
};